import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client. Exported as a singleton so non-React code
 * (FCM message handler, websocket events) can invalidate queries directly.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
